import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '@/components/common/LanguageSwitcher';
import {
  Nav, Brand, BrandLogo, BrandName, NavLinks, NavLink, NavActions, CtaButton,
} from './Navbar.styled';

// Self-serve signup is gated behind a build-time flag (default OFF).
const SIGNUP_ENABLED = import.meta.env.VITE_SIGNUP_ENABLED === 'true';
// Assumed app signup origin (no app URL found elsewhere in the repo).
const SIGNUP_URL = 'https://app.scribia.pl/signup';

export default function Navbar() {
  const { t } = useTranslation();

  return (
    <Nav>
      <Brand href="#top">
        <BrandLogo src="/logo_32_32.png" alt="Scribia" />
        <BrandName>Scribia</BrandName>
      </Brand>
      <NavLinks>
        <NavLink href="#funkcje">{t('nav.features')}</NavLink>
        <NavLink href="#jak-to-dziala">{t('nav.howItWorks')}</NavLink>
        <NavLink href="#konta-sadow">{t('nav.courtAccounts')}</NavLink>
        <NavLink href="#portal-sadowy">{t('nav.portalIntegration')}</NavLink>
        <NavLink href="#cennik">{t('nav.pricing')}</NavLink>
        <NavLink href="#faq">{t('nav.faq')}</NavLink>
      </NavLinks>
      <NavActions>
        <LanguageSwitcher />
        {SIGNUP_ENABLED && <CtaButton href={SIGNUP_URL}>{t('nav.tryFree')}</CtaButton>}
      </NavActions>
    </Nav>
  );
}
